import Struct from "@yume-chan/struct";
import { ScrcpyControlMessageType } from "./type.js";
export const ScrcpyRotateDeviceControlMessage = new Struct().uint8("type", ScrcpyControlMessageType.RotateDevice);
//# sourceMappingURL=rotate-device.js.map